import { axiosInstance } from "@/axios/interceptors";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

const IntercomTokenSchema = z.object({
	token: z.string(),
});

export type IntercomToken = z.infer<typeof IntercomTokenSchema>;

export async function getIntercomToken() {
	const response = await axiosInstance.post("/auth/intercom/token");
	return ZodSentryReporter.parse(IntercomTokenSchema, response);
}
